import React, {createElement} from 'react';
import {Form, Button, Scrollable, Icon, Flex, Tag, TagsList, EditableTag} from 'components';
import {isEqual, flow, toggle, partial, over, includes, useField, useNamedSelector, useBuffer, mapValues, useFormikContext, transform, useRafState} from 'helpers';
import {store, tags} from 'store';

export function CurrentTags({add, remove, selected, popup}) {
  const [isEditing, setEditing] = useRafState();
  const {ordered, byId} = useNamedSelector('tags.tags');
  const initialValues = {
    deleted: [],
    tags: mapValues(byId, 'name')
  };
  return (
    <Form initialValues={initialValues} onSubmit={flow(tags.update, store.dispatch)}>
      {({values}) =>
        <>
          <Flex className={['middle', 'justified']}>
            <h5>{ ordered.length ? 'Your tags' : 'You have no tags.' }</h5>
            {ordered.length > 0 &&
              <Button
                type={isEditing ? 'submit' : 'button'}
                className={['tiny', isEditing && 'primary', isEditing && 'filled']}
                icon={isEditing ? 'check' : 'pencil'}
                onClick={over(() => setEditing(!isEditing), popup.bounce)}
                children={isEditing ? 'Save'.concat(isEqual(initialValues, values) ? '' : ' *') : 'Edit'}
              />
            }
          </Flex>
          <Scrollable className={['spacing', 'medium']}>
            <TagsList>
              {ordered.map(tag => createElement(isEditing ? TagInput : Tag, {
                key: tag.id,
                id: tag.id,
                selected: includes(selected, tag),
                onClick: partial(includes(selected, tag) ? remove : add, tag),
                children: tag.name
              }))}
            </TagsList>

          </Scrollable>
        </>
      }
    </Form>
  );
}

const TagInput = ({id}) => {
  const {values: {deleted, tags}, setFieldValue} = useFormikContext();
  const byName = transform(tags, (accumulator, tag, id) => {
    accumulator[tag.toLowerCase()] = id;
  });
  const isMarked = deleted.includes(id);
  const [field, , {setValue}] = useField(`tags.${id}`);
  const [control] = useBuffer({
    value: field.value,
    onChange({value, valueBeforeFocus, update}) {
      if (!value.trim()) {
        setFieldValue('deleted', toggle(deleted, id));
        update({value: valueBeforeFocus});
      } else if (byName[value.toLowerCase().trim()] && byName[value.toLowerCase().trim()] !== id) {
        update({value: valueBeforeFocus});
      } else {
        setValue(value);
      }
    }
  });
  return (
    <EditableTag value={control.value} placeholder="Tag.." className={isMarked && 'deleted'}>
      <input {...control} disabled={isMarked} />
      <Icon name={isMarked ? 'undo' : 'trash'} onClick={() => setFieldValue('deleted', toggle(deleted, id))} />
    </EditableTag>
  );
};
